import { unsafeCSS, html } from "lit";
import { property, queryAssignedElements } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { e } from "../../scoped-registry-mixin-2fqf-E5n.js";
import { isMobile } from "../../utilities/is-mobile.js";
import { LeafElement } from "../../components/leaf-element.js";
const styles = '@charset "UTF-8";\n/* ------------------------------------*\\\n    #TYPOGRAPHY PLACEHOLDERS\n\\*------------------------------------ */\n:host .chc-c-product-card__group--columns-2, :host .chc-c-product-card__group--columns-3, :host .chc-c-product-card__group--columns-4 {\n  display: grid;\n}\n\n/*\n  Hiding class, making content visible only to screen readers but not visually ("sr" meaning "screen-reader")\n  Is the hidden content read by a screen reader?	- Yes\n  Will the hidden element affect the document layout? - No\n  Will the hidden element’s box model be rendered? - No\n  Does the element detect clicks or focus? - Yes\n  https://css-tricks.com/comparing-various-ways-to-hide-things-in-css/#method-5-the-visually-hidden-class\n*/\n:host {\n  display: grid;\n}\n:host .chc-c-product-card__group--columns-2 {\n  row-gap: var(--leaf-spacing-24);\n}\n@media (min-width: 48rem) {\n  :host .chc-c-product-card__group--columns-2 {\n    grid-gap: var(--leaf-spacing-24);\n    grid-template-columns: minmax(0, calc(8.3333333333% * 6 - 12px)) minmax(0, calc(8.3333333333% * 6 - 12px));\n  }\n}\n:host .chc-c-product-card__group--columns-3 {\n  row-gap: var(--leaf-spacing-24) !important;\n}\n@media (min-width: 48rem) {\n  :host .chc-c-product-card__group--columns-3 {\n    grid-gap: var(--leaf-spacing-24);\n    grid-template-columns: minmax(0, calc(8.3333333333% * 6 - 12px)) minmax(0, calc(8.3333333333% * 6 - 12px));\n  }\n}\n@media (min-width: 48rem) {\n  :host .chc-c-product-card__group--columns-3 {\n    row-gap: var(--leaf-spacing-48) !important;\n  }\n}\n@media (min-width: 60rem) and (min-width: 48rem) {\n  :host .chc-c-product-card__group--columns-3 {\n    grid-gap: var(--leaf-spacing-24);\n    grid-template-columns: minmax(0, calc(8.3333333333% * 4 - 16px)) minmax(0, calc(8.3333333333% * 4 - 16px)) minmax(0, calc(8.3333333333% * 4 - 16px));\n  }\n}\n:host .chc-c-product-card__group--columns-4 {\n  row-gap: var(--leaf-spacing-24);\n}\n@media (min-width: 48rem) {\n  :host .chc-c-product-card__group--columns-4 {\n    grid-gap: var(--leaf-spacing-24);\n    grid-template-columns: minmax(0, calc(8.3333333333% * 3 - 18px)) minmax(0, calc(8.3333333333% * 3 - 18px)) minmax(0, calc(8.3333333333% * 3 - 18px)) minmax(0, calc(8.3333333333% * 3 - 18px));\n  }\n}';
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const PRODUCT_CARD_HEADER_SELECTOR = "chc-product-card-header";
const PRODUCT_CARD_HEADER_ClASS_SELECTOR = ".chc-c-product-card__header";
const _CHCProductCardGroup = class _CHCProductCardGroup extends e(LeafElement) {
  constructor() {
    super(...arguments);
    this.columns = 1;
    this.equalizeHeaderHeights = () => {
      var _a, _b, _c;
      let maxHeight = 0;
      (_a = this._productCards) == null ? void 0 : _a.forEach((card) => {
        var _a2, _b2;
        ((_b2 = (_a2 = card.querySelector(PRODUCT_CARD_HEADER_SELECTOR)) == null ? void 0 : _a2.shadowRoot) == null ? void 0 : _b2.querySelector(PRODUCT_CARD_HEADER_ClASS_SELECTOR)).style.removeProperty("height");
      });
      if (!isMobile("md")) {
        (_b = this._productCards) == null ? void 0 : _b.forEach((card) => {
          var _a2, _b2;
          const offsetHeight = ((_b2 = (_a2 = card.querySelector(PRODUCT_CARD_HEADER_SELECTOR)) == null ? void 0 : _a2.shadowRoot) == null ? void 0 : _b2.querySelector(PRODUCT_CARD_HEADER_ClASS_SELECTOR)).offsetHeight;
          if (offsetHeight > maxHeight) {
            maxHeight = offsetHeight;
          }
        });
        (_c = this._productCards) == null ? void 0 : _c.forEach((card) => {
          var _a2, _b2;
          const element = (_b2 = (_a2 = card.querySelector(PRODUCT_CARD_HEADER_SELECTOR)) == null ? void 0 : _a2.shadowRoot) == null ? void 0 : _b2.querySelector(PRODUCT_CARD_HEADER_ClASS_SELECTOR);
          const style = window.getComputedStyle(element);
          const paddingTop = parseInt(style.getPropertyValue("padding-top"));
          const paddingBottom = parseInt(style.getPropertyValue("padding-bottom"));
          element.style.height = `${maxHeight - paddingTop - paddingBottom}px`;
        });
      }
    };
  }
  async firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    await this.updateComplete;
    if (this._productCards && this._productCards.length > 1) {
      setTimeout(() => {
        this.equalizeHeaderHeights();
        window.onresize = this.equalizeHeaderHeights;
      }, 100);
    }
  }
  render() {
    const componentClassName = {
      "chc-c-product-card__group": true,
      "chc-c-product-card__group--columns-2": this.columns === 2,
      "chc-c-product-card__group--columns-3": this.columns === 3,
      "chc-c-product-card__group--columns-4": this.columns === 4
    };
    return html`<div class=${classMap(componentClassName)}><slot name="card"></slot></div>`;
  }
};
_CHCProductCardGroup.styles = unsafeCSS(styles);
let CHCProductCardGroup = _CHCProductCardGroup;
__decorateClass([
  property({ type: Number, reflect: true })
], CHCProductCardGroup.prototype, "columns", 2);
__decorateClass([
  queryAssignedElements({ slot: "card" })
], CHCProductCardGroup.prototype, "_productCards", 2);
export {
  CHCProductCardGroup
};
//# sourceMappingURL=product-card-group.component.js.map
